
import { onScrollTo } from './../utility/onScrollTo'
import { after } from './../utility/transition'
import { type } from './../modules/type'


function getOffset(element, context, center = false) {
   const rect = element.getBoundingClientRect()
   const contextRect = context.getBoundingClientRect()   
   return {
		left : rect.left - contextRect.left + (center ? rect.width/2 : 0),
		top : rect.top - contextRect.top + (center ? rect.height/2 : 0),
		height : rect.height,
		width : rect.width
   }
}

const drawLines = (section, svgPinNode, content, immediate = false) => {



	const lineX = section.querySelector('.m-locations__line-horizontal')
	const lineY = section.querySelector('.m-locations__line-vertical')

	const contentOffset = getOffset(content, section)
	// fix contentOffset.top because of animation on content element
	contentOffset.top = section.clientHeight/2 - contentOffset.height/2

	const removeOld = () => {
		if (immediate) {
			lineX.style.transition = 'none'
			lineY.style.transition = 'none'
		}
		lineX.classList.add('draw--reverse')
		lineY.classList.add('draw--reverse')
		lineX.classList.remove('draw')
		lineY.classList.remove('draw')
	}

	const drawNew = () => {

		lineX.classList.remove('draw--reverse')
		lineY.classList.remove('draw--reverse')

		// basic drawing lines around box
		if (!svgPinNode) {
			lineX.style.left = `${contentOffset.left - 80}px`
			lineX.style.top = `${contentOffset.top - 40}px`
			lineX.style.width = `${contentOffset.width + 80}px`

			lineY.style.left = `${contentOffset.left}px`
			lineY.style.top = `${contentOffset.top - 80}px`
			lineY.style.height = `${contentOffset.height + 80}px`

		} else {
			const svgOffset = getOffset(svgPinNode, section)

			// center of pin
			const pinX = svgOffset.left + svgOffset.width/2 - 1
			const pinY = svgOffset.top + svgOffset.height/2 - 1

			// point where lines cross
			const pointX = contentOffset.left
			const pointY = pinY

			const doCross = (pointY < contentOffset.top || pointY > contentOffset.top+contentOffset.height)

			let lineXTransformWidth = 0
			let lineYTransformHeight = 0
			let lineYTransformTop = 0
			let lineYReverseDraw = false

			if (doCross) {
				lineXTransformWidth = 60;
				if (pointY < contentOffset.top) {
					const diff = contentOffset.top - pointY
					lineYTransformTop -= diff + 60
					lineYTransformHeight += diff + 60
				}
				if (pointY > contentOffset.top + contentOffset.height) {
					const diff = pointY - (contentOffset.top + contentOffset.height)
					lineYReverseDraw = true
					lineYTransformHeight += diff + 60
				}
			}

			if (lineYReverseDraw) lineY.classList.add('draw--reverse')
			lineX.style.left = `${pinX}px`
			lineX.style.top = `${pinY}px`
			lineX.style.width = `${pointX - pinX + lineXTransformWidth}px`
			lineY.style.left = `${pointX}px`
			lineY.style.top = `${contentOffset.top + lineYTransformTop}px`
			lineY.style.height = `${contentOffset.height + lineYTransformHeight}px`
		}


		lineX.classList.add('draw')
		lineY.classList.add('draw')

		if (immediate) {
			lineX.style.transition = ''
			lineY.style.transition = ''
		}
	}

	const run = () => {
		drawNew()
		if (typeof callback === 'function') callback()
	}

	const first = (!lineX.classList.contains('draw'))

	if (first || immediate) {
		run()
	} else {
		setTimeout(run, 500)
		// after(lineY, run)
		removeOld()
	}
	
}

const createTransition = (section) => {

	let currentContent = null
	let currentSvgPinNode = null

	window.addEventListener('resize', () => {
		setTimeout(() => drawLines(section, currentSvgPinNode, currentContent, true), 100)
	})

	return (svgPinNode, content) => {
		drawLines(section, svgPinNode, content)

		const hideOld = () => {
			currentContent && currentContent.classList.remove('is-open')
		}
		const showNew = () => {
			const typeTitle = content.querySelector('.rich-heading-lower')
			typeTitle && type(typeTitle)
			content.classList.add('is-open')
			currentContent = content
		}

		if (currentContent) {
			hideOld()
			setTimeout(showNew, 200)
		}

		if (!currentContent) showNew()

		currentContent = content
		currentSvgPinNode = svgPinNode
	}
}


const init = (section) => {

	// elements
	const closeButtons = [...section.querySelectorAll('[data-location-close]')]
	const initial = section.querySelector('[data-location-initial]')
	const pins = [...section.querySelectorAll('.svg-map__pin')]

	// transition func between contents
	const showContent = createTransition(section)

	// animate in map
	const svg = section.querySelector('.svg-map')
	// uses `className +=` because svg.classList not supported on IE11
	svg.setAttribute('class', svg.getAttribute('class') + ' svg-map--visible')

	const closeHandler = event => {
		event.preventDefault()
		showContent(null, initial)
	}

	const openHandler = event => {
		const pin = event.currentTarget
		const id = pin.getAttribute('data-id')
		const content = section.querySelector(`[data-location-id="${id}"]`)
		content && showContent(pin, content)
	}

	// setup event listeners
	closeButtons.map(button => button.addEventListener('click', closeHandler))
	pins.map(pin => pin.addEventListener('click', openHandler))

	// initial load
	showContent(null, initial)
}


export default () => {
	onScrollTo('.m-locations', init, { offset : -200 })
}